<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-title>Изменение поля «{{ fieldTitle }}»</card-title>
      <card-content class="pt-6">
        <v-row>
          <v-col v-if="dic && typ == 'combobox'" cols="12">
            <v-combobox
              v-model="val"
              :label="fieldTitle"
              outlined
              dense
              hide-details
              :items="dic"
              :cache-items="false"
              @blur="onComboBlur"
            />
          </v-col>
          <v-col v-else-if="typ == 'memo'" cols="12">
            <v-textarea
              id="form-text-input-val"
              v-model="val"
              :label="fieldTitle"
              outlined
              dense
              hide-details
              rows="4"
            />
          </v-col>
          <v-col v-else-if="typ == 'text'" cols="12">
            <v-text-field
              id="form-text-input-val"
              v-model="val"
              :label="fieldTitle"
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </card-content>
      <card-actions>
        <v-btn
          :id="`mass-change-${fieldName}-execute`"
          color="primary"
          depressed
          @click="onExecute"
        >
          Выполнить
        </v-btn>
        <v-btn
          :id="`mass-change-${fieldName}-cancel`"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Отменить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
export default {
  name: "MassAssignment",
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean,
    fieldName: {
      type: String,
      required: true
    },
    fieldTitle: {
      type: String,
      required: true
    },
    typ: {
      type: String,
      default: "text"
    },
    dic: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      val: ""
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.resetForm();
      } else if (!newVal) {
        this.$emit("close");
      }
    }
  },

  methods: {
    async onExecute() {
      const { val, fieldName } = this;
      this.$emit("apply", { data: { val }, fieldName });
      this.dialog = false;
    },

    resetForm() {
      this.val = "";
    },

    onComboBlur(v) {
      this.val = v.srcElement.value;
    }
  }
};
</script>
